import { object, string } from 'yup';

export interface SignInFormProps {
  email: string;
  password: string;
}

export const SignInSchema = object().shape({
  email: string()
    .email('errors.email is not valid')
    .required('errors.email is required'),
  password: string()
    .min(8, 'errors.password is too short')
    .required('errors.password is required')
});
